import { CursorPageSchema, CursorPaginatedResponseSchema } from 'notable-common';
import { z } from 'zod';
import { FlowReferenceTableRowDataSchema } from './referenceTable.js';
const pageSchema = CursorPageSchema.optional()
    .default({ size: 25 })
    .describe('Page size, up to 500, and the cursor returned as meta.page.after by the previous page.');
export const FlowReferenceTableMetadataSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    organizationId: z
        .uuid()
        .nullable()
        .describe('The owning organization, or null for a global table shared by every organization.'),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    deleted: z.iso.datetime().nullable(),
});
export const FlowReferenceTablePageQuerySchema = z
    .object({
    q: z
        .string()
        .min(1)
        .max(200)
        .describe('Return only tables whose name contains this.')
        .optional(),
    // An empty array would serialize to no parameter at all, and so ask for every organization.
    organizationId: z
        .union([z.uuid(), z.array(z.uuid()).min(1)])
        .describe('Return only tables of this organization, or of any of these organizations.')
        .optional(),
    page: pageSchema,
})
    .strict();
export const FlowReferenceTablePageResponseSchema = CursorPaginatedResponseSchema(FlowReferenceTableMetadataSchema);
export const FlowReferenceTableSummarySchema = z.object({
    referenceTable: FlowReferenceTableMetadataSchema,
    columnNames: z.array(z.string()),
    rowCount: z.number().int().nonnegative(),
});
export const FlowReferenceTableRowsQuerySchema = z.object({ page: pageSchema }).strict();
export const FlowReferenceTableRowsResponseSchema = CursorPaginatedResponseSchema(FlowReferenceTableRowDataSchema);
//# sourceMappingURL=read.js.map